<nav
  class="bg-white sm:bg-background fixed top-0 left-0 right-0 z-32 h-17 border-b border-gray-200"
>
  <div class="mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex justify-between h-16">
      <div class="flex items-center">
        <!-- Clickable area -->
        <button
          type="button"
          (click)="onMenuButtonClick()"
          class="flex items-center gap-2 p-2 rounded-md cursor-pointer"
        >
          <span class="sr-only">Abrir menú</span>

          <!-- Icon -->
          <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>

          <!-- Logo -->
          @if (companyLogoUrl()) {
            <img class="h-9 w-auto" [src]="companyLogoUrl()" alt="Company logo" />
          }

          <!-- Title -->
          <h1 class="text-[14px] font-bold whitespace-nowrap">
            {{ pageTitle | translate }}
          </h1>
        </button>
      </div>

      <div class="flex items-center space-x-4">
        <!-- User Button & Dropdown -->
        <div class="relative">
          <button
            (click)="toggleUserDropdown($event)"
            type="button"
            class="flex items-center space-x-2 rounded-full px-2 py-1 cursor-pointer"
            id="user-menu-button"
            aria-expanded="false"
            aria-haspopup="true"
          >
            <span class="sr-only">Menú usuario</span>

            <!-- Avatar -->
            <div
              class="h-8 w-8 rounded-full flex items-center justify-center bg-white text-primary text-[12px] font-semibold overflow-hidden"
            >
              <ng-container
                *ngIf="userData.photoUrl !== '' && userData.photoUrl !== null; else initialsAvatar"
              >
                <img
                  class="h-full w-full object-cover"
                  [src]="userData.photoUrl"
                  alt="User avatar"
                />
              </ng-container>

              <ng-template #initialsAvatar>
                {{ getInitials(userData.name, userData.lastName) }}
              </ng-template>
            </div>

            <!-- Username -->
            <span class="hidden sm:inline text-[14px]">
              {{ userData.name }}
            </span>

            <!-- Arrow Down Icon -->
            <i class="fa-solid fa-caret-down"></i>
          </button>

          @if (showUserDropdown) {
            <div
              class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 z-10"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="user-menu-button"
            >
              <a (click)="onLogout()" href="#" class="block px-4 py-2 text-[14px]" role="menuitem">
                {{ 'SHARED.DASHBOARD_NAVBAR.LOGOUT' | translate }}
              </a>
            </div>
          }
        </div>

        <!-- Notifications Button -->
        <button type="button" class="relative rounded-full p-2 cursor-pointer">
          <span class="sr-only">Ver notificaciones</span>

          <!-- Bell Icon -->
          <i class="fa fa-bell text-xl"></i>

          <!-- Notification badge (opcional) -->

          <span class="absolute top-1 right-1 h-2 w-2 rounded-full bg-red-500"></span>
        </button>
      </div>
    </div>
  </div>
</nav>
